import { Directive } from '../classes';

export class SysDebugComponent extends Directive {
    public static get $name() {
        return 'sysDebug';
    }

    public static get $controller() {
        const Ctrl = function ($element: JQuery) {
            console.log(`debug::controller::${$element.attr('name')}`);
        };
        Ctrl.$inject = ['$element'];
        return Ctrl;
    }

    public compile(element: JQuery, attributes: angular.IAttributes): any {
        console.log(`debug::compile::${attributes['name']}`, element);
        return {
            pre: (scope: angular.IScope, element: JQuery, attributes: angular.IAttributes) => {
                console.log(`debug::pre::${attributes['name']}`, scope, element);
            },
            post: (scope: angular.IScope, element: JQuery, attributes: angular.IAttributes) => {
                console.log(`debug::post::${attributes['name']}`, scope, element);
            }
        };
    }

    public template(element: JQuery, attributes: angular.IAttributes): string {
        console.log(`debug::template::${attributes['name']}`);
        return element.html();
    }
}
